import { apiRequest } from './index';

export const fetchIncomeTaxRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/income-taxes/' + id, {}, success, failure);
}

export const fetchIncomeTaxesRequest = ( selectedDate, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/income-taxes?selectedDate=${selectedDate}`, {}, success, failure);
}

export const createIncomeTaxRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/income-taxes',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const createIncomeTaxGroupRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/income-taxes/group',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editIncomeTaxRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/income-taxes/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deleteIncomeTaxRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/income-taxes/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}

export const getEffectiveDateList = ( success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/income-taxes/effective-date/list',
        { method: 'GET' },
        success,
        failure
    )
}
